'use strict';

angular.module('licensure.helpers')
    .factory('Cache', ['LocalDatabase', '$state', 'Format', function (LocalDatabase, $state, Format) {
        return {
            setState: function (table, data) {
                data.state = $state.current.name;
                return LocalDatabase.putWithIndex(table, 'state', $state.current.name, data);
            },

            getState: function (table) {
                return LocalDatabase.get(table, $state.current.name);
            },

            save: function (table, data, index) {
                if (index == null) {
                    index = 'id';
                }

                return LocalDatabase.putWithIndex(table, index, Format.evaluateJSON(data, index), data);
            },

            get: function (table, index) {
                return LocalDatabase.get(table, index);
            },

            getAll: function (table) {
                return LocalDatabase.getAll(table);
            },

            remove: function (table, index) {
                return LocalDatabase.remove(table, index);
            }
        }
    }])
;